import { render, staticRenderFns } from "./retur-create-form.vue?vue&type=template&id=2b385b27&"
import script from "./retur-create-form.vue?vue&type=script&lang=js&"
export * from "./retur-create-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports